import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["message", "features"];
import React from 'react';
import CustomState from './CustomState';
import PropTypes from 'prop-types';
import isArray from 'lodash/fp/isArray';
import isEmpty from 'lodash/fp/isEmpty';
var NotBookedState = function NotBookedState(props) {
  var message = props.message,
    features = props.features,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var combinedMessages = /*#__PURE__*/React.createElement(React.Fragment, null, message && /*#__PURE__*/React.createElement("div", {
    className: "text-medium margin-bottom-20"
  }, message), features && isArray(features) && !isEmpty(features) && /*#__PURE__*/React.createElement("ul", {
    className: "feature-list"
  }, features.map(function (feature, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, feature);
  })));
  return /*#__PURE__*/React.createElement(CustomState, _extends({
    message: combinedMessages
  }, remainingProps));
};
NotBookedState.defaultProps = {
  icon: 'rioglyph-stars'
};
NotBookedState.propTypes = {
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  features: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    href: PropTypes.string
  })),
  condensed: PropTypes.bool
};
export default NotBookedState;